// extracted by mini-css-extract-plugin
export default {"CurPage":"CurPage_CurPage__m-A1u","currentPage":"CurPage_currentPage__2ZBGb"};